<template>
  <div></div>
</template>

<script>
export default {
  name: 'MetaManager',
  props: {
    title: {
      type: String,
      default: 'Demat Account Opening | Open Free Demat Account with Zebu'
    },
    description: {
      type: String,
      default: 'Complete your KYC process with Zebu for seamless trading and investment experience.'
    },
    keywords: {
      type: String,
      default: 'zebu, kyc, trading, investment, demat account, online trading'
    },
    ogTitle: {
      type: String,
      default: 'Demat Account Opening | Open Free Demat Account with Zebu'
    },
    ogDescription: {
      type: String,
      default: 'Complete your KYC process with Zebu for seamless trading and investment experience.'
    },
    ogImage: {
      type: String,
      default: '/favicon.ico'
    },
    twitterTitle: {
      type: String,
      default: 'Demat Account Opening | Open Free Demat Account with Zebu'
    },
    twitterDescription: {
      type: String,
      default: 'Complete your KYC process with Zebu for seamless trading and investment experience.'
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          content: this.description
        },
        {
          name: 'keywords',
          content: this.keywords
        },
        // Open Graph / Facebook
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:title',
          content: this.ogTitle
        },
        {
          property: 'og:description',
          content: this.ogDescription
        },
        {
          property: 'og:image',
          content: this.ogImage
        },
        // Twitter
        {
          property: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          property: 'twitter:title',
          content: this.twitterTitle
        },
        {
          property: 'twitter:description',
          content: this.twitterDescription
        },
        {
          property: 'twitter:image',
          content: this.ogImage
        }
      ]
    }
  }
}
</script> 